import LoginForm from './LoginForm';
import PasswordResetRequestForm from './PasswordResetRequestForm';
import SignupForm from './SignupForm';
import { AuthFormView } from './types';
import { dataPreferVerticalLayout } from './AuthForm.css';
import * as styles from './AuthForm.css';

interface AuthFormProps {
  formView: AuthFormView;
  onChangeFormView: (newFormView: AuthFormView) => void;
  shouldNavigateOnLogin?: boolean;
  onLoginSuccess?: () => void;
  preferVerticalLayout?: boolean;
  shouldHideSignupLink?: boolean;
}

/**
 * Renders a login, signup, or password reset form
 * @param {AuthFormView} formView - Determines which form view to show
 * @param {function} onChangeFormView - Callback to update the current view for the auth form
 * @param {boolean} [shouldNavigateOnLogin] - Whether the page should preform a post-login redirect after a login, this should be false for modals
 * @param {function} [onLoginSuccess] - Callback for when a login is completed successfully
 * @param {boolean} [preferVerticalLayout] - Whether to prefer a vertical layout for the LoginOrSetup form, this is useful for smaller containers
 * @param {boolean} [shouldHideSignupLink] - Whether to hide the signup link below the login button, useful for partner sites
 */
export default function AuthForm({
  formView,
  onChangeFormView,
  shouldNavigateOnLogin = false,
  onLoginSuccess = undefined,
  preferVerticalLayout = false,
  shouldHideSignupLink = false,
}: AuthFormProps) {
  switch (formView) {
    case AuthFormView.Login:
      return (
        <div className={styles.singleFormContainer}>
          <LoginForm
            onChangeFormView={onChangeFormView}
            shouldNavigateOnLogin={shouldNavigateOnLogin}
            onLoginSuccess={onLoginSuccess}
            shouldHideSignupLink={shouldHideSignupLink}
          />
        </div>
      );
    case AuthFormView.Signup:
      return (
        <div className={styles.singleFormContainer}>
          <SignupForm
            onChangeFormView={onChangeFormView}
            shouldNavigateOnLogin={shouldNavigateOnLogin}
            onLoginSuccess={onLoginSuccess}
          />
        </div>
      );
    case AuthFormView.LoginOrSetup:
      return (
        <div
          className={styles.loginOrSetupContainer}
          {...dataPreferVerticalLayout(preferVerticalLayout)}
        >
          <LoginForm
            onChangeFormView={onChangeFormView}
            shouldNavigateOnLogin={shouldNavigateOnLogin}
            onLoginSuccess={onLoginSuccess}
            shouldHideSignupLink
          />
          <span
            {...dataPreferVerticalLayout(preferVerticalLayout)}
            className={styles.divider}
          ></span>
          <PasswordResetRequestForm
            shouldShowSetupInsteadOfReset
            onChangeFormView={onChangeFormView}
          />
        </div>
      );
    default:
      return (
        <div className={styles.singleFormContainer}>
          <PasswordResetRequestForm onChangeFormView={onChangeFormView} />
        </div>
      );
  }
}
